<template>
  <div class="truck-sighting slide">
    <VerticalAnimation :animation="animation" :background="background" />
    <div class="vertical-layout animated fadeIn delay-2s">
      <p class="store">STORE 1755</p>
      <h1>Truck Sighting</h1>
      <p>Meanwhile at store 1755, an APS is told by a cashier that a customer is attempting to check out with hidden merchandise. When the customer is intercepted, they abandon the transaction and leave. The customer is spotted getting into an orange pickup.</p>
    </div>
    <router-link to="/roadblock">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import VerticalAnimation from '@/components/VerticalAnimation.vue'
import NextButton from '@/components/NextButton.vue'

import TruckSighting from '@/assets/truck-sighting.js'
import VerticalImage from '@/assets/pawn-shop.png'

export default {
  name: 'truck-sighting',
  components: {
    VerticalAnimation,
    NextButton
  },
  data() {
    return {
      animation: TruckSighting,
      background: VerticalImage
    }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
 h1 {
   margin-bottom: 0;
 }

 p { 
   font-size: 16px;
   margin-top: 10px;
   line-height: 17px;
 }
</style>
